import React from 'react';
import { Button } from '../shared/Button';
import { ArrowRightIcon, CalendarIcon } from 'lucide-react';
export const CTASection = () => {
  return <section className="w-full bg-gradient-to-br from-[#231232] via-[#1a0d24] to-[#231232] py-20 sm:py-28 border-t border-b border-[#6805DA]/20" data-id="element-133" data-mp="3e1fx4lfi6doo">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-134" data-mp="34becy4q9tff1">
        <span className="inline-block px-4 py-1.5 bg-[#FFC501]/10 text-[#FFC501] rounded-full text-sm font-medium mb-6" data-id="element-135" data-mp="3099ix4vwugrv">
          LIMITED AVAILABILITY
        </span>
        <h2 className="text-4xl sm:text-5xl lg:text-6xl font-outfit font-bold mb-6 sm:mb-8 text-white leading-tight" data-id="element-136" data-mp="2v8v9pjikp0s9">
          Ready to Transform
          <br className="hidden sm:inline" data-id="element-137" data-mp="2lc8sr5tdatvi" /> Your Career?
        </h2>
        <p className="text-lg sm:text-xl text-gray-300 mb-10 sm:mb-12 max-w-3xl mx-auto" data-id="element-138" data-mp="2led428tliv5t">
          Apply now for ApplyPass Platinum. Only 4 spots remaining for Q1. Our
          clients see an average 127% increase in compensation within 3-4
          months.
        </p>
        <div className="flex flex-col sm:flex-row justify-center items-center gap-6" data-id="element-139" data-mp="2zogy7205oed8">
          <Button variant="gradient-primary" size="lg" className="w-full sm:w-auto text-lg sm:text-xl font-semibold shadow-xl" href="/start" data-id="element-140" data-mp="34pwj8u2c2kvm">
            <CalendarIcon className="mr-2 w-5 h-5" data-id="element-141" data-mp="2urqjoj401qtx" /> Schedule a Consultation
          </Button>
          <Button variant="outline" size="lg" className="w-full sm:w-auto text-lg" href="#testimonials" data-id="element-142" data-mp="3ihukkipszch8">
            See Success Stories <ArrowRightIcon className="ml-2 w-5 h-5" data-id="element-143" data-mp="38ri1yw1jttdq" />
          </Button>
        </div>
        {/* Trust Indicators */}
        <div className="mt-12 flex flex-wrap justify-center items-center gap-6 text-white/60" data-id="element-144" data-mp="3doi7n5uhku4b">
          <div className="flex items-center gap-2" data-id="element-145" data-mp="5980vkfnj0q7">
            <CalendarIcon size={16} data-id="element-146" data-mp="a0q3se18jbdt" />
            <span data-id="element-147" data-mp="a1rm93kkz05k">30-min consultation</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-148" data-mp="jwq4sgle3rbk">
            <CheckIcon size={16} data-id="element-149" data-mp="jw6o137h78z4" />
            <span data-id="element-150" data-mp="juce0jxqt19t">No obligation</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-151" data-mp="eyx2hyn7jhgk">
            <LockIcon size={16} data-id="element-152" data-mp="aw0cvnz92l34" />
            <span data-id="element-153" data-mp="auz2zmtz04mz">100% confidential</span>
          </div>
        </div>
      </div>
    </section>;
};
function CheckIcon(props: React.SVGProps<SVGSVGElement> & {
  size?: number;
}) {
  return <svg width={props.size || 24} height={props.size || 24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props} data-id="element-154" data-mp="yw1mj6y0a13">
      <polyline points="20 6 9 17 4 12" data-id="element-155" data-mp="3nb2opc49s2hu" />
    </svg>;
}
function LockIcon(props: React.SVGProps<SVGSVGElement> & {
  size?: number;
}) {
  return <svg width={props.size || 24} height={props.size || 24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props} data-id="element-156" data-mp="3ebpgemrvtjyp">
      <rect x="3" y="11" width="18" height="11" rx="2" ry="2" data-id="element-157" data-mp="1oxzh1vkwplxf" />
      <path d="M7 11V7a5 5 0 0 1 10 0v4" data-id="element-158" data-mp="1tt52yueb70li" />
    </svg>;
}